import type { VirtualBackgroundFilter } from '@doxyme/types';

export enum VirtualBackgroundGroups {
  NoEffectsBlur = 'NoEffectsBlur',
  Simple = 'Simple',
  Office = 'Office',
  Medical = 'Medical',
  Outdoor = 'Outdoor',
  Fun = 'Fun',
}

export type VirtualBackground = {
  /**
   * A unique ID that is compatible with backgroundEffect in OG.
   */
  index: number;
  group: VirtualBackgroundGroups;
  name: string;
  filter: VirtualBackgroundFilter | null;
  metadata: {
    title: string;
    label?: string;
    thumbnail?: string;
  };
  default?: boolean;
};

export type GroupVirtualBackground = {
  key: VirtualBackgroundGroups;
  backgrounds: VirtualBackground[];
};
